import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Label,
} from "recharts";

// Data from Jan to Oct
const data = [
  { month: "Jan", value: 60 },
  { month: "Feb", value: 72 },
  { month: "Mar", value: 30 },
  { month: "Apr", value: 55 },
  { month: "May", value: 10 },
  { month: "Jun", value: 60 },
  { month: "Jul", value: 15 },
  { month: "Aug", value: 75 },
  { month: "Sep", value: 80 },
  { month: "Oct", value: 60 },
];

const OperationalLineChart = () => {
  return (
    <ResponsiveContainer width="99%" height={300}>
      <LineChart
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
      >
        <XAxis dataKey="month" axisLine={{ stroke: "#D9D9D9" }}>
          <Label value="Months" position="insideBottom" offset={-20} />
        </XAxis>
        <YAxis
          domain={[0, 100]}
          ticks={[0, 25, 50, 75, 100]}
          axisLine={{ stroke: "#D9D9D9" }}
        />
        <Tooltip cursor={false} />
        <Line
          type="linear"
          dataKey="value"
          stroke="#4A0B4D"
          strokeWidth={1}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default OperationalLineChart;
